module.exports = require("react-router");